import { Instagram, Facebook, Music2, MessageCircle, Send, ArrowUpRight } from "lucide-react";
import { useLang, CONTACTS } from "../i18n";
import { Reveal, SectionHead } from "./Reveal";

export const Socials = () => {
  const { t } = useLang();
  const items = [
    { name: "Instagram", icon: Instagram, href: "#", testid: "social-instagram" },
    { name: "Facebook", icon: Facebook, href: "https://www.facebook.com/profile.php?id=61574129461376", testid: "social-facebook" },
    { name: "TikTok", icon: Music2, href: "#", testid: "social-tiktok" },
    { name: "WhatsApp", icon: MessageCircle, href: CONTACTS.whatsapp, testid: "social-whatsapp" },
    { name: "Telegram", icon: Send, href: "#", testid: "social-telegram" },
  ];
  return (
    <section id="socials" data-testid="socials-section" className="mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-32">
      <SectionHead num={t.socials.num} title={t.socials.title} sub={t.socials.sub} testid="socials-head" />
      <div className="grid grid-cols-2 gap-px border border-white/10 bg-white/10 sm:grid-cols-3 lg:grid-cols-5">
        {items.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.06} className="bg-[#0A0A0A]">
            <a
              data-testid={s.testid}
              href={s.href}
              target={s.href.startsWith("http") ? "_blank" : undefined}
              rel="noreferrer"
              className="group flex h-full flex-col items-center justify-center gap-4 p-10 transition-colors duration-500 hover:bg-[#FF5A00]"
            >
              <s.icon size={30} className="text-[#FF5A00] transition-colors duration-500 group-hover:text-white" />
              <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-neutral-300 transition-colors duration-500 group-hover:text-white">
                {s.name}
                <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
